import getApiClient from '@/plugins/api-client'

export default {
    loadSymplaTokens: function() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('sympla_tokens')
            .then(result => {
                self.symplaTokens = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },
}
